import { AppRoutes } from './routes';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './lib/query-client';
import { Suspense } from 'react';
import { Loading } from '@/components/ui/loading';
import AuthInitializer from './components/auth/AuthInitializer';
import { Toaster } from '@/components/ui/toaster';
import { AgentVersionGenerationProvider } from '@/components/teammate-studio/AgentVersionGenerationProvider';
import { ScenarioRunTrackingProvider } from '@/components/eval-studio/ScenarioRunTrackingProvider';

// Fallback loading component
const LoadingFallback = () => <Loading fullPage />;

function App() {
  return (
    <>
      <QueryClientProvider client={queryClient}>
        <AuthInitializer>
          <AgentVersionGenerationProvider>
            <ScenarioRunTrackingProvider>
              <Suspense fallback={<LoadingFallback />}>
                <AppRoutes />
              </Suspense>
            </ScenarioRunTrackingProvider>
          </AgentVersionGenerationProvider>
        </AuthInitializer>
      </QueryClientProvider>
      <Toaster />
    </>
  );
}

export default App;
